import { createType } from 'framework/utils/createType';

export const PurchaseDetailTabTypes = createType('contents', 'payments');
export type PurchaseDetailTabType = typeof PurchaseDetailTabTypes[number];
